import Panel from '@admin/components/panel'

const mapPropsToPanel = (props, context) => ({
  title: 't(TLDs)',
  collection: {
    endpoint: `/api/admin/truevail/admin/deliverability/segments/${props.segment.id}/tlds`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Domain)', key: 'domain.name', sort: 'domain', primary: true },
      { label: 't(Warming)', key: 'warming_enabled', collapsing: true, format: 'check_times' },
      { label: 't(Queued)', key: 'queued_count', collapsing: true, align: 'right' }
    ],
    defaultSort: { key: 'domain', order: 'asc' },
    empty: {
      svg: 'globe',
      title: 't(No TLD Domains)',
      text: 't(There are no TLD domains for this segment)'
    },
    entity: 'domain_segment',
    onClick: (record) => context.router.push(`/admin/truevail/admin/domain_segments/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)